import { LegalDisclaimer } from '@absg/api-party';
import { BaseService, NimAlertService, PartyService } from '@absg/nim-client-shared';
import { Injectable } from '@angular/core';
import { StationAuthenticationService } from 'core.services/station-authentication.service';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LegalDisclaimerResolver extends BaseService {
  constructor(
    private partyService: PartyService,
    private nimAlertService: NimAlertService,
    private stationAuthenticationService: StationAuthenticationService,
  ) {
    super();
  }

  resolve(): Observable<string> {
    return this.partyService.getLegalDisclaimerText().pipe(
      take(1),
      catchError(() => {
        this.nimAlertService.showErrorAlert('Legal Disclaimer', new Error('Unable to retrieve Legal Disclaimer text'));
        this.stationAuthenticationService.redirectToLogoutPage().pipe(take(1)).subscribe();
        return of(undefined as LegalDisclaimer);
      }),
      map((text) => !!text ? text.legalDisclaimerText : ''),
    );
  }
}
